import React from 'react';
import './ModelOutput.css';

const ModelOutput = ({model, output, onClose, onRegenerate, onClear, title, icon}) => {
    return (
        <div className="ModelOutput">
            <div className="ModelOutput-header">
                <img src={icon} alt={title} className="ModelOutput-icon-img"
                     style={{width: '20px', height: '20px', marginRight: '5px'}}/>
                <h3>{title}</h3>
                <div className="ModelOutput-actions">
                    <button className="ModelOutput-action" onClick={() => {
                        navigator.clipboard.writeText(output).then(() => {
                            alert('Content copied to clipboard!');
                        });
                    }} title="复制">
                        📋
                    </button>
                    <button
                        className="ModelOutput-action"
                        onClick={() => onRegenerate(model)}
                        title="重新生成"
                    >
                        🔄
                    </button>
                    <button
                        className="ModelOutput-action"
                        onClick={() => onClear(model)}
                        title="清除"
                    >
                        🗑
                    </button>
                    <button className="ModelOutput-close" onClick={() => onClose(model)} title="关闭">
                        ✖
                    </button>
                </div>
            </div>
            <div className="content-wrapper">
                <pre className="ModelOutput-content">{output}</pre>
            </div>
        </div>
    );
};

export default ModelOutput;
